import React, { useEffect } from "react";
import { Box, TextField, MenuItem, Button, Grid } from "@mui/material";
import { useSearchParams } from "react-router-dom";

interface SearchAreaProps {
  formConfig: Record<string, string>[];
}

const SearchArea: React.FC<SearchAreaProps> = (props) => {
  const { formConfig } = props;
  const [dropdownValue, setDropdownValue] = React.useState<
    Record<string, string>
  >(formConfig[0]);
  const [textInputValue, setTextInputValue] = React.useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // On component load, check for query parameters
    const queryParamKey = searchParams.keys().next().value || "";
    const queryParamValue = searchParams.get(queryParamKey);

    if (queryParamKey && queryParamValue) {
      const matchedOption = formConfig.find(
        (config) => config.key === queryParamKey
      );

      if (matchedOption) {
        setDropdownValue(matchedOption);
        setTextInputValue(queryParamValue);
      }
    }
  }, [searchParams]);

  const handleDropdownChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedOption = formConfig.find(
      (config) => config.key === event.target.value
    );
    if (selectedOption) {
      setDropdownValue(selectedOption);
    }
  };

  const handleTextInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTextInputValue(event.target.value);
  };

  const handleSubmit = () => {
    setSearchParams({ [dropdownValue.key]: textInputValue }); // Update query params on button click
  };

  return (
    <Box p={2}>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {/* Dropdown and Text Input on the same row */}
        <Grid item xs={2}>
          <TextField
            select
            fullWidth
            label="Select Search option"
            value={dropdownValue.key}
            onChange={handleDropdownChange}
            variant="outlined"
            size="medium"
          >
            {formConfig.map((config) => (
              <MenuItem key={config.key} value={config.key}>
                {config.displayValue}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={6}>
          <TextField
            fullWidth
            label={`Enter ${dropdownValue.displayValue}`}
            value={textInputValue}
            onChange={handleTextInputChange}
            variant="outlined"
            size="medium"
          />
        </Grid>

        <Grid item xs={1}>
          <Button
            size="large"
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchArea;
